<template>
  <v-radio-group
    v-model="field.value"
    :rules="validationRules"
    @update:model-value="$emit('input', field.value)"
    :class="{ required: field.required }">
    <div v-for="feature of field.dropDownValues" :key="feature" class="mb-4">
      <div class="d-flex flex-row">
        <v-radio :value="feature" :id="feature" />
        <div>
          <p>
            <label :for="feature">
              <strong>{{ featureData(feature).title }}</strong>
            </label>
          </p>
          <p>
            <small>{{ featureData(feature).description }}</small>
          </p>
        </div>
      </div>
    </div>
  </v-radio-group>
</template>

<script>
import customFieldTypeMixin from '@/modules/custom_fields/mixins/customFieldTypeMixin';

export default {
  name: 'custom-field-action',
  mixins: [customFieldTypeMixin],
  methods: {
    featureData(feature) {
      return this.novaCore.CustomFormsFeaturesData[feature];
    }
  }
};
</script>
